import { getConsents } from '../stores/consents';

const profileLoader = async ({ injectReducer, dispatch }) => {
  const { default: profileReducer, load: loadProfilePageData } = await import(
    '../stores/forms/profile'
  );

  injectReducer(profileReducer);

  return Promise.all([
    dispatch(getConsents()),
    dispatch(loadProfilePageData())
  ]);
};

export default profileLoader;
